<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <p style="color: #0e6ba9;" class="nombreBoton" @click="siguenteFlujo(data.item.idSolicitudEtapa, data.item)" >
      {{ data.item.nombrePaciente }}
    </p>
  </div>

</template>

<script>
import {MotorService} from "@/apiServices/motor/MotorService";

export default {
  name: "BandejaLinkPacienteReplicaCEComponente",
  props: {
    data: Object,
    resource: Object,
  },
  data(){
    return{
      motorServicio: new MotorService(),
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
    }
  },
  created(){
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    siguenteFlujo(idSolicitudEtapa, item) {
      const params = {
        idSolicitudEtapa: idSolicitudEtapa,
        objeto: null
      }
      this.motorServicio.obtenerSiguenteFlujo(params)
          .then((respuesta) => {
            let url = respuesta.data.urlPantalla;
            if (respuesta.data.parametros.length > 0) {
              respuesta.data.parametros.forEach((p, i) => {

                url = url+"/"+ p.valor;
                if (i + 1 < respuesta.data.parametros.length) {
                  url = url + "/";
                }
              });
              url = url + "/"+item.idSolicitudEtapa;
              url = url + "/" + respuesta.data.idEtapa;
            }
            this.$router.push(url);
          })
          .finally(() => {
            this.loader = false;
          });
    }
  },
};
</script>

<style scoped>
.nombreBoton {
  cursor: pointer;
}
.nombreBoton:hover {
  cursor: pointer;
  color: #0c69a7;
  font-weight: bold;
}
</style>
